import { render, staticRenderFns } from "./RequestViewTabInventory.vue?vue&type=template&id=ec58a18a"
import script from "./RequestViewTabInventory.vue?vue&type=script&lang=js"
export * from "./RequestViewTabInventory.vue?vue&type=script&lang=js"
import style0 from "./RequestViewTabInventory.vue?vue&type=style&index=0&id=ec58a18a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports